module.exports = __webpack_public_path__ + "img/2.cf96eff1.png";